import React from 'react';
import PropTypes from 'prop-types';
import { maybe, rd } from '@passionware/monads';
import { rowLevelValidation } from 'v5/platform/row-level-validation';
import {
  ComboboxDataRenderer,
  ComboboxItem,
  ComboboxList,
  useComboboxQuery
} from 'v5/design-system/Combobox.js';
import { myServices } from 'v5/services/services.connected.app.js';
import { ResourceMenuItemContent } from 'v1/components/shared/search/SearchField/ResourceSelect.js';
import { resourceQueryUtils } from 'v5/api/resource/resource.api';

const BookResourceFlyoverResourceContents = ({
  resourceTypeId,
  onResourceAssign
}) => {
  const onAssignResource = ({ id }) => onResourceAssign(id);

  return (
    <ComboboxList>
      <Results
        resourceTypeId={resourceTypeId}
        onAssignResource={onAssignResource}
      />
    </ComboboxList>
  );
};

function Results(props) {
  const query = useComboboxQuery();
  const { resourceTypeId } = props;
  const data = rd.useLastWithPlaceholder(
    myServices.resourceService.useList(
      resourceQueryUtils.getBuilder().build(q => [
        q.withSearch(query),
        q.withMergedFilters({
          resource_type_id: maybe.map(resourceTypeId, resourceTypeId => ({
            operator: 'matchAny',
            value: [resourceTypeId]
          }))
        })
      ])
    )
  );
  return (
    <ComboboxDataRenderer>
      {rd.map(data, data => {
        return rowLevelValidation
          .validDataFromRows(data.items)
          .map(resource => (
            <ComboboxItem
              compact
              className="px-4"
              onSelect={() => props.onAssignResource(resource)}
              key={resource.id}
              value={String(resource.id)}
            >
              <ResourceMenuItemContent
                checkbox={false}
                resource={resource}
                hideRole={false}
              />
            </ComboboxItem>
          ));
      })}
    </ComboboxDataRenderer>
  );
}

BookResourceFlyoverResourceContents.propTypes = {
  slotQuery: PropTypes.object,
  setResourceId: PropTypes.func
};

export default BookResourceFlyoverResourceContents;
